import { render, staticRenderFns } from "./transaction-history.vue?vue&type=template&id=d4be6bfa&"
import script from "./transaction-history.vue?vue&type=script&lang=js&"
export * from "./transaction-history.vue?vue&type=script&lang=js&"
import style0 from "./transaction-history.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports